/** CSS clamps each opacity before parent and animation contributions are composed. */
export function effectiveGroupOpacity(value:number,animated:unknown):number{
 const alpha=(v:unknown)=>{const n=typeof v==='number'||typeof v==='string'?Number(v):1;return Number.isFinite(n)?Math.max(0,Math.min(1,n)):1;};
 return alpha(value)*alpha(animated);
}

/** The pinned web composer needs an isolated layer before applying group alpha. */
export function groupOpacityStyle(value:number,animated:unknown,clientRender:boolean){
 const opacity=effectiveGroupOpacity(value,animated);
 if(!clientRender||opacity===0||opacity===1)return {opacity};
 // A transparent zero-radius shadow requests precomposition without changing pixels.
 // Apply opacity to that completed layer, rather than separately to every child.
 return {opacity:1,filter:`drop-shadow(0px 0px 0px transparent) opacity(${opacity})`};
}

/** Logical RGBA surface estimate, not an OS/GPU memory ceiling. */
export function assertGroupCompositeBudget(boxes:readonly {from:number;durationInFrames:number;width:number;height:number}[]){
 const events:{frame:number;pixels:number}[]=[];
 const fail=()=>{throw Error('반투명 그룹의 합성 영역이 너무 큽니다. 사본에서 그룹 크기를 줄이거나 불투명도를 100%로 바꾼 뒤 출력해 주세요.');};
 for(const box of boxes){
  if(!Number.isFinite(box.width)||!Number.isFinite(box.height)||box.width>8192||box.height>8192)fail();
  const pixels=Math.ceil(box.width)*Math.ceil(box.height);
  if(pixels<0||!Number.isSafeInteger(pixels))fail();
  events.push({frame:box.from,pixels},{frame:box.from+box.durationInFrames,pixels:-pixels});
 }
 events.sort((a,b)=>a.frame-b.frame||a.pixels-b.pixels);
 let active=0;for(const event of events){active+=event.pixels;if(active>16*1024*1024)fail();}
}
